// extracted by mini-css-extract-plugin
module.exports = {"tupacGrid":"nb-z","tupacHeader":"ob-z","tupacHeader2":"pb-z","tupacMenu":"qb-z","tupacMenu2":"rb-z","tupacMain":"sb-z","tupacMain2":"tb-z"};